/*
 * Fovory product page (sections/fovory-product.liquid).
 * Gallery, options, real urgency (deal countdown, low stock, delivery dates), buy bar,
 * picture viewer. Add to bag itself is the theme's product-form (cart drawer).
 */
(() => {
  const root = document.querySelector('[data-fv-pdp]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';

  const $ = (s, c = root) => c.querySelector(s);
  const $$ = (s, c = root) => [...c.querySelectorAll(s)];
  const wide = window.matchMedia('(min-width: 1024px)');
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  let data = { variants: [], t: {} };
  try { data = JSON.parse($('[data-fv-pdp-json]').textContent); } catch (e) { /* keep defaults */ }
  const t = data.t || {};
  const fill = (s, map) => Object.keys(map).reduce((a, k) => a.split('[' + k + ']').join(map[k]), s || '');
  const lang = (document.documentElement.lang || 'en').toLowerCase();
  const locale = lang.startsWith('en') ? 'en-GB' : lang.startsWith('pt') ? 'pt-PT' : lang;
  const two = (n) => String(Math.max(0, Math.floor(n))).padStart(2, '0');

  /* ---------------- Gallery ---------------- */
  const gal = $('[data-fv-gal]');
  const stage = $('[data-fv-stage]');
  const slides = $$('[data-fv-slide]');
  const thumbs = $$('[data-fv-thumb]');
  const dots = $$('.fv-gal__dots i');
  const countEl = $('[data-fv-count]');
  const n = slides.length;
  let idx = Math.max(0, slides.findIndex((s) => s.classList.contains('is-active')));

  function paint(i) {
    idx = i;
    slides.forEach((s, k) => s.classList.toggle('is-active', k === i));
    thumbs.forEach((b, k) => (k === i ? b.setAttribute('aria-current', 'true') : b.removeAttribute('aria-current')));
    dots.forEach((d, k) => d.classList.toggle('is-on', k === i));
    if (countEl) countEl.textContent = i + 1;
    const th = thumbs[i];
    if (th && th.parentElement.scrollHeight > th.parentElement.clientHeight) {
      const box = th.parentElement;
      const top = th.offsetTop - (box.clientHeight - th.offsetHeight) / 2;
      box.scrollTo({ top, behavior: reduce.matches ? 'auto' : 'smooth' });
    }
  }

  function go(i, scroll = true) {
    if (!n) return;
    i = ((i % n) + n) % n;
    paint(i);
    if (!wide.matches && scroll && stage) {
      stage.scrollTo({ left: slides[i].offsetLeft - stage.offsetLeft - parseFloat(getComputedStyle(stage).paddingLeft || 0), behavior: reduce.matches ? 'auto' : 'smooth' });
    }
  }

  thumbs.forEach((b) => b.addEventListener('click', () => go(+b.dataset.fvThumb)));
  const prev = $('[data-fv-prev]');
  const next = $('[data-fv-next]');
  prev && prev.addEventListener('click', () => go(idx - 1));
  next && next.addEventListener('click', () => go(idx + 1));
  gal && gal.addEventListener('keydown', (e) => {
    if (e.target.closest('input, textarea')) return;
    if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); }
    if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); }
  });

  // Phone and tablet: the stage is a row of pictures; follow the swipe.
  let scrollTick = null;
  stage && stage.addEventListener('scroll', () => {
    if (wide.matches || scrollTick) return;
    scrollTick = requestAnimationFrame(() => {
      scrollTick = null;
      const pad = parseFloat(getComputedStyle(stage).paddingLeft || 0);
      let best = 0;
      let dist = Infinity;
      slides.forEach((s, k) => {
        const d = Math.abs(s.offsetLeft - stage.offsetLeft - pad - stage.scrollLeft);
        if (d < dist) { dist = d; best = k; }
      });
      if (best !== idx) paint(best);
    });
  }, { passive: true });
  wide.addEventListener && wide.addEventListener('change', () => go(idx, true));

  // At the top of the page the gallery fills the window under the header and breadcrumb.
  const grid = $('.fv-pdp');
  // One height for the desktop gallery: the space under the header and breadcrumb on load, so the
  // whole picture is in view at the top of the page and stays the same size while it is held.
  // The gallery's place on the page is measured with the page at rest and kept; it is measured again
  // only when the width changes (the layout can move), never while scrolling.
  let galTop = null;
  let lastW = window.innerWidth;
  function fit(remeasure) {
    if (!gal || !grid) return;
    if (remeasure || galTop === null) galTop = grid.getBoundingClientRect().top + window.scrollY;
    const h = Math.min(window.innerHeight - galTop - 16, window.innerHeight - 96 - 16);
    gal.style.setProperty('--fv-gal-fit', Math.max(0, Math.round(h)) + 'px');
  }
  fit(true);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => fit(window.scrollY === 0));
  window.addEventListener('resize', () => {
    const w = window.innerWidth;
    fit(w !== lastW && window.scrollY === 0);
    lastW = w;
  });
  window.addEventListener('load', () => fit(window.scrollY === 0));

  /* ---------------- Picture viewer ---------------- */
  const lb = $('[data-fv-lb]');
  const lbIm = $('[data-fv-lb-im]');
  const lbN = $('[data-fv-lb-n]');
  let lbI = 0;
  const bigSrc = (img) => {
    if (!img) return '';
    const set = (img.getAttribute('srcset') || '').split(',').map((x) => x.trim().split(' ')[0]).filter(Boolean);
    return set.length ? set[set.length - 1] : img.currentSrc || img.src;
  };
  function lbShow(i) {
    lbI = ((i % n) + n) % n;
    const img = slides[lbI].querySelector('img');
    lbIm.src = bigSrc(img);
    lbIm.alt = img ? img.alt : '';
    if (lbN) lbN.textContent = lbI + 1;
  }
  function lbOpen(i) {
    if (!lb || typeof lb.showModal !== 'function') return;
    lbShow(i);
    lb.showModal();
    document.documentElement.classList.add('fv-lb-open');
  }
  if (lb) {
    $$('[data-fv-zoom]').forEach((b) => b.addEventListener('click', () => lbOpen(+b.dataset.fvZoom)));
    lb.addEventListener('close', () => {
      document.documentElement.classList.remove('fv-lb-open');
      go(lbI);
      const z = slides[lbI] && slides[lbI].querySelector('[data-fv-zoom]');
      if (z) z.focus({ preventScroll: true });
    });
    lb.addEventListener('click', (e) => {
      if (e.target.closest('[data-fv-lb-close]') || e.target === lb || e.target.classList.contains('fv-lb__in')) lb.close();
      if (e.target.closest('[data-fv-lb-prev]')) lbShow(lbI - 1);
      if (e.target.closest('[data-fv-lb-next]')) lbShow(lbI + 1);
    });
    lb.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { e.preventDefault(); lbShow(lbI - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); lbShow(lbI + 1); }
    });
    let sx = null;
    lb.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', (e) => {
      if (sx === null || n < 2) return;
      const dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 50) lbShow(lbI + (dx < 0 ? 1 : -1));
      sx = null;
    }, { passive: true });
  }

  /* ---------------- Size guide ---------------- */
  const sg = $('[data-fv-sg]');
  const sgOpen = $('[data-fv-sg-open]');
  if (sg && sgOpen && typeof sg.showModal === 'function') {
    sgOpen.addEventListener('click', () => {
      sg.showModal();
      document.documentElement.classList.add('fv-lb-open');
    });
    sg.addEventListener('click', (e) => {
      if (e.target === sg || e.target.closest('[data-fv-sg-close]')) sg.close();
    });
    sg.addEventListener('close', () => {
      document.documentElement.classList.remove('fv-lb-open');
      sgOpen.focus({ preventScroll: true });
    });
  }

  /* ---------------- Options and variant ---------------- */
  const groups = $$('[data-fv-opt]');
  const idInput = $('[data-fv-id]');
  const addBtn = $('[data-fv-add]');
  const addText = $('[data-fv-add-text]');
  const prBox = $('[data-fv-pr]');
  const priceEl = $('[data-fv-price]');
  const compareEl = $('[data-fv-compare]');
  const saveEl = $('[data-fv-save]');
  const saveAmt = $('[data-fv-save-amt]');
  const pctEls = $$('[data-fv-pct]');
  const soldTag = $('[data-fv-soldtag]');
  const freeEl = $('[data-fv-ship-free]');
  const barPrice = $('[data-fv-bar-price]');
  const barSub = $('[data-fv-bar-sub]');
  const barAdd = $('[data-fv-bar-add]');
  const sizeIdx = groups.findIndex((g) => g.classList.contains('fv-opt--size'));
  const stockEl = $('[data-fv-stock]');
  const low30El = $('[data-fv-low30]');
  const low30Amt = $('[data-fv-low30-amt]');
  const notifyBox = $('[data-fv-notify]');
  const notifyH = $('[data-fv-notify-h]');
  const notifyBody = $('[data-fv-notify-body]');
  let lowText = '';

  const selected = () => groups.map((g) => {
    const i = g.querySelector('input:checked');
    return i ? i.value : null;
  });
  const exact = (sel) => data.variants.find((v) => v.options.every((o, k) => o === sel[k]));
  let current = exact(selected()) || data.variants.find((v) => String(v.id) === (idInput && idInput.value));

  function paintOptions(sel) {
    groups.forEach((g, gi) => {
      const val = g.querySelector('[data-fv-opt-val]');
      if (val) val.textContent = sel[gi] || '';
      g.querySelectorAll('input').forEach((input) => {
        const cand = sel.slice();
        cand[gi] = input.value;
        const v = exact(cand);
        const label = g.querySelector('label[for="' + input.id + '"]');
        if (!label) return;
        label.classList.toggle('is-out', !(v && v.available));
        label.classList.toggle('is-low', !!(v && v.available && v.qty));
      });
    });
    // Low stock, real numbers: every size (with the other choices kept) at or under the threshold.
    const items = [];
    if (sizeIdx > -1) {
      groups[sizeIdx].querySelectorAll('input').forEach((input) => {
        const cand = sel.slice();
        cand[sizeIdx] = input.value;
        const v = exact(cand);
        if (v && v.available && v.qty) items.push(fill(v.qty === 1 ? t.leftOne : t.leftMany, { n: v.qty, v: input.value }));
      });
    }
    lowText = items.length ? fill(t.lowOnly, { x: items.join(', ') }) : '';
  }

  function paintStock(v) {
    const ok = !!(v && v.available);
    if (stockEl) {
      let txt = lowText;
      if (!txt && ok && v.qty && sizeIdx === -1) txt = fill(t.lowOnly, { x: v.qty === 1 ? t.onlyOne : fill(t.onlyMany, { n: v.qty }) });
      stockEl.textContent = txt || t.inStock;
      stockEl.classList.toggle('is-low', !!txt);
      stockEl.hidden = !ok;
    }
    if (notifyBox) {
      notifyBox.hidden = ok || !v;
      if (v && !ok) {
        const sizeVal = sizeIdx > -1 ? v.options[sizeIdx] : v.title;
        if (notifyH) notifyH.textContent = groups.length ? fill(t.outV, { v: sizeVal }) : t.outAll;
        if (notifyBody) notifyBody.value = 'Back in stock: ' + (data.title || '') + ' (' + v.title + ') ' + (data.url || '') + '?variant=' + v.id;
      }
    }
  }

  function paintVariant(v) {
    const ok = !!(v && v.available);
    const label = !v ? t.unav : ok ? t.add : t.sold;
    if (idInput) idInput.value = v ? v.id : '';
    if (addBtn) addBtn.disabled = !ok;
    if (addText) addText.textContent = label;
    if (barAdd) { barAdd.disabled = !ok; barAdd.textContent = label; }
    if (soldTag) soldTag.hidden = !(v && !v.available);
    const shipBox = $('[data-fv-ship]');
    if (shipBox) shipBox.hidden = !ok;
    paintStock(v);
    if (!v) { prBox && prBox.classList.add('is-out'); return; }
    if (low30El) { low30El.hidden = !v.low30; if (low30Amt) low30Amt.textContent = v.low30; }
    if (priceEl) priceEl.textContent = v.price;
    if (barPrice) { barPrice.textContent = v.price; barPrice.parentElement.classList.toggle('is-sale', !!v.compare); }
    if (compareEl) { compareEl.textContent = v.compare; compareEl.hidden = !v.compare; }
    if (saveEl) { saveEl.hidden = !v.save; if (saveAmt) saveAmt.textContent = v.save; }
    pctEls.forEach((p) => { p.hidden = !v.pct; p.textContent = '−' + v.pct + '%'; });
    if (prBox) { prBox.classList.toggle('is-sale', !!v.compare); prBox.classList.toggle('is-out', !v.available); }
    if (freeEl && data.free) freeEl.textContent = v.more ? fill(t.freeMore, { x: v.more }) : t.freeOn;
    if (barSub && !dealEnds) barSub.textContent = groups.length ? v.title : '';
  }

  groups.forEach((g) => g.addEventListener('change', () => {
    const sel = selected();
    current = exact(sel);
    paintOptions(sel);
    paintVariant(current);
    if (current) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', current.id);
      window.history.replaceState({}, '', url.toString());
      if (current.media) {
        const k = slides.findIndex((s) => s.dataset.mediaId === String(current.media));
        if (k > -1 && k !== idx) go(k);
      }
      document.dispatchEvent(new CustomEvent('variant:changed', { detail: { variant: current } }));
    }
  }));

  /* ---------------- Deal countdown ---------------- */
  const deal = $('[data-fv-deal]');
  const dealEnds = deal ? parseInt(deal.dataset.ends, 10) * 1000 : 0;
  const cd = deal ? { d: $('[data-fv-cd="d"]', deal), h: $('[data-fv-cd="h"]', deal), m: $('[data-fv-cd="m"]', deal), s: $('[data-fv-cd="s"]', deal) } : null;
  function tickDeal() {
    if (!deal) return;
    const left = Math.floor((dealEnds - Date.now()) / 1000);
    if (left <= 0) {
      deal.hidden = true;
      if (barSub) barSub.textContent = current && groups.length ? current.title : '';
      return false;
    }
    cd.d.textContent = two(left / 86400);
    cd.h.textContent = two((left % 86400) / 3600);
    cd.m.textContent = two((left % 3600) / 60);
    cd.s.textContent = two(left % 60);
    if (barSub) barSub.textContent = (t.endsIn || '') + ' ' + Math.floor(left / 86400) + 'd ' + two((left % 86400) / 3600) + 'h ' + two((left % 3600) / 60) + 'm';
    return true;
  }
  if (deal && tickDeal()) {
    const iv = setInterval(() => { if (!tickDeal()) clearInterval(iv); }, 1000);
  }

  /* ---------------- Delivery dates ---------------- */
  const ship = $('[data-fv-ship]');
  function lisbonNow() {
    try {
      const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Lisbon', hour: 'numeric', minute: 'numeric', weekday: 'short', hour12: false }).formatToParts(new Date());
      const get = (k) => (parts.find((p) => p.type === k) || {}).value;
      return { h: parseInt(get('hour'), 10) % 24, m: parseInt(get('minute'), 10), wd: get('weekday') };
    } catch (e) {
      const d = new Date();
      return { h: d.getHours(), m: d.getMinutes(), wd: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][d.getDay()] };
    }
  }
  function addWorkingDays(from, days) {
    const d = new Date(from.getFullYear(), from.getMonth(), from.getDate());
    let left = days;
    while (left > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) left -= 1;
    }
    return d;
  }
  function paintShip() {
    if (!ship) return;
    const min = parseInt(ship.dataset.min, 10) || 0;
    const max = parseInt(ship.dataset.max, 10) || min;
    const cutoff = parseInt(ship.dataset.cutoff, 10);
    const now = lisbonNow();
    const workday = now.wd !== 'Sat' && now.wd !== 'Sun';
    const beforeCut = !isNaN(cutoff) && workday && now.h < cutoff;
    let start = new Date();
    // After the cut-off, or with no cut-off set but the day already gone, count from the next working day.
    if (!isNaN(cutoff) && !beforeCut) start = addWorkingDays(start, 1);
    const fmt = new Intl.DateTimeFormat(locale, { weekday: 'short', day: 'numeric', month: 'short' });
    const fmtDay = new Intl.DateTimeFormat(locale, { weekday: 'short', day: 'numeric' });
    const da = addWorkingDays(start, min);
    const db = addWorkingDays(start, max);
    // Same month: the month is said once ("Thu 5 and Mon 9 Nov").
    const sameMonth = da.getMonth() === db.getMonth() && da.getFullYear() === db.getFullYear();
    const a = sameMonth && min !== max ? fmtDay.format(da) : fmt.format(da);
    const b = fmt.format(db);
    const when = $('[data-fv-ship-when]', ship);
    if (when && min > 0) when.textContent = a === b ? fill(t.getOne, { a }) : fill(t.get, { a, b });
    const cut = $('[data-fv-cut]', ship);
    if (cut) {
      if (beforeCut) {
        const mins = (cutoff - now.h) * 60 - now.m;
        const txt = (mins >= 60 ? Math.floor(mins / 60) + ' ' + t.h + ' ' : '') + (mins % 60) + ' ' + t.m;
        cut.textContent = fill(t.cutoff, { t: txt });
        cut.hidden = false;
      } else {
        cut.hidden = true;
      }
    }
  }
  paintShip();
  if (ship && ship.dataset.cutoff && ship.dataset.cutoff !== 'off') setInterval(paintShip, 30000);

  /* ---------------- Buy bar (below 1024px) ---------------- */
  const bar = $('[data-fv-bar]');
  const cta = $('.fv-pdp__cta');
  // At the very end of the page (the "Delivering to" row) the tab bar comes back.
  const footer = document.querySelector('.fv-shipto') || document.querySelector('.fv-site-footer');
  let pastCta = false;
  let footerIn = false;
  function paintBar() {
    if (!bar) return;
    const on = !wide.matches && pastCta && !footerIn;
    bar.classList.toggle('is-on', on);
    bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    if (barAdd) barAdd.tabIndex = on ? 0 : -1;
    document.documentElement.classList.toggle('fv-pdp-bar', on);
  }
  if (bar && cta && 'IntersectionObserver' in window) {
    new IntersectionObserver(([e]) => {
      pastCta = !e.isIntersecting && e.boundingClientRect.top < 0;
      paintBar();
    }).observe(cta);
    if (footer) new IntersectionObserver(([e]) => { footerIn = e.isIntersecting; paintBar(); }).observe(footer);
    wide.addEventListener && wide.addEventListener('change', paintBar);
  }
  barAdd && barAdd.addEventListener('click', () => {
    const form = addBtn && addBtn.form;
    if (!form || addBtn.disabled) return;
    if (form.requestSubmit) form.requestSubmit(addBtn);
    else addBtn.click();
  });

  /* ---------------- First paint ---------------- */
  if (groups.length) paintOptions(selected());
  if (current) paintVariant(current);

  /* ---------------- Recently viewed and favourites ---------------- */
  window.addEventListener('load', () => {
    try {
      const key = 'm-recent-viewed-products';
      if (typeof getCookie === 'function' && typeof setCookie === 'function') {
        let list = [];
        try { list = JSON.parse(getCookie(key) || '[]'); } catch (e) { list = []; }
        const h = root.dataset.handle;
        list = [h].concat(list.filter((x) => x !== h)).slice(0, 20);
        setCookie(key, JSON.stringify(list));
      }
    } catch (e) { /* ignore */ }
    try { window.MinimogTheme && MinimogTheme.Wishlist && MinimogTheme.Wishlist.setWishlistButtonsState && MinimogTheme.Wishlist.setWishlistButtonsState(); } catch (e) { /* ignore */ }
  });
})();
